import { render } from "./User.vue?vue&type=template&id=1aa40402&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1aa40402"

export default script